import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProcedures = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "m15.178 5.845-2.356-2.357A1.67 1.67 0 0 0 11.643 3H5.667C4.746 3 4 3.746 4 4.667v11.666C4 17.254 4.746 18 5.667 18H14c.92 0 1.667-.746 1.667-1.667v-9.31c0-.441-.176-.865-.489-1.178",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#748094",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M15.667 7.167h-3.334a.834.834 0 0 1-.833-.834V3M6.5 12.167h5M6.5 14.667h3.608"
	})]
});
export default SvgProcedures;
